import React from 'react';
import { Button } from '../../components/ui/Button';
import { useFocusTrap } from '../../app/hooks/useFocusTrap';
import { useEscapeKey } from '../../app/hooks/useEscapeKey';
interface AssessmentErrorModalProps {
  message: string;
  onClose: () => void;
}
export function AssessmentErrorModal({
  message,
  onClose
}: AssessmentErrorModalProps) {
  const focusTrapRef = useFocusTrap(true);
  useEscapeKey(onClose);
  return <>
      <div className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-40" onClick={onClose} data-id="element-711" data-mp="xdhkx2g3j9so" />
      
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-712" data-mp="12bj21htyoz1i">
        <div ref={focusTrapRef} role="dialog" aria-modal="true" aria-labelledby="assessment-error-title" className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-8" data-id="element-713" data-mp="1792rldw40y8r">
          
          <div className="text-center" data-id="element-714" data-mp="em8bet6bsl13">
            <div className="text-6xl mb-4" data-id="element-715" data-mp="el6nvp84i62h">📋</div>
            <h2 id="assessment-error-title" className="text-2xl font-bold text-slate-900 mb-3" data-id="element-716" data-mp="jk00lffl5t1l">
              
              Toets kan niet starten
            </h2>
            <p className="text-slate-600 mb-6 leading-relaxed" data-id="element-717" data-mp="szbzs82ysrrw">{message}</p>
            <Button onClick={onClose} variant="primary" size="lg" fullWidth data-id="element-718" data-mp="nywnzkybzsc1">
              Begrepen
            </Button>
          </div>
        </div>
      </div>
    </>;
}